// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-webmap-display-navigation-menu {
  box-sizing: border-box;
  background-color: var(--primary);
  padding: 8px 0 !important;
  width: 50px;
  height: 100%;
  overflow: auto;
  color: var(--on-primary-text);
}
.ngw-webmap-display-navigation-menu .ngw-webmap-display-navigation-menu-item {
  cursor: pointer;
  height: 40px;
  user-select: none;
  text-align: center;
}
.ngw-webmap-display-navigation-menu .ngw-webmap-display-navigation-menu-item > svg.icon {
  opacity: 0.5;
  font-size: 24px;
}
.ngw-webmap-display-navigation-menu .ngw-webmap-display-navigation-menu-item.active > svg.icon,
.ngw-webmap-display-navigation-menu .ngw-webmap-display-navigation-menu-item:hover > svg.icon {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/display/component/NavigationMenu.less"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,6BAAA;AACJ;AARA;EAUQ,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AACR;AACQ;EACI,YAAA;EACA,eAAA;AACZ;AAEQ;;EAEI,UAAA;AAAZ","sourcesContent":[".ngw-webmap-display-navigation-menu {\n    box-sizing: border-box;\n    background-color: var(--primary);\n    padding: 8px 0 !important;\n    width: 50px;\n    height: 100%;\n    overflow: auto;\n    color: var(--on-primary-text);\n\n    .ngw-webmap-display-navigation-menu-item {\n        cursor: pointer;\n        height: 40px;\n        user-select: none;\n        text-align: center;\n\n        & > svg.icon {\n            opacity: 0.5;\n            font-size: 24px;\n        }\n\n        &.active > svg.icon,\n        &:hover > svg.icon {\n            opacity: 1;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
